import React from 'react';
import {AbstractLayoutProps} from '../../@types/components/layouts/AbstractLayout';

type P = AbstractLayoutProps;

export default abstract class AbstractLayout<Props extends P = P, State = any> extends React.Component<Props, State> {
    protected supportsBreadcrumbs = true;

    constructor(props: Props) {
        super(props);

        this.renderBreadcrumbs = this.renderBreadcrumbs.bind(this);
    }

    protected renderContent() {
        return <>
            {this.isSupportsBreadcrumbs() ? this.renderBreadcrumbs() : null}

            {this.props.children}
        </>;
    }

    protected renderBreadcrumbs() {
        return this.props.breadcrumbs ?? null;
    }

    protected isSupportsBreadcrumbs(): boolean {
        return this.supportsBreadcrumbs;
    }
}
